import React from 'react'
import { SvgIcon, SvgIconProps } from '@material-ui/core'

export const ChevronDownIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path fillRule='evenodd' clipRule='evenodd' d='M12 16C11.772 16 11.545 15.923 11.36 15.768L5.35997 10.768C4.93597 10.415 4.87797 9.78401 5.23197 9.36001C5.58497 8.93601 6.21497 8.87901 6.63997 9.23201L12.011 13.708L17.373 9.39301C17.803 9.04701 18.433 9.11501 18.779 9.54501C19.125 9.97501 19.057 10.604 18.627 10.951L12.627 15.779C12.444 15.926 12.222 16 12 16Z' fill={props.htmlColor || '#2B2B2B'} />
    </SvgIcon>
  )
}
